import { defineMessages } from "react-intl";
import "./MessageDescriptor";

var messages = {
    date: {
        id: 'app.info.date',
        defaultMessage: 'Date'
    },
    version: {
        id: 'app.info.version',
        defaultMessage: 'Version'
    }
};

var definedMessages = defineMessages(messages);

export default definedMessages;